<template>
  <div>
    <v-container class="pt-0 mt-5">
      <v-card flat>
        <div>
          <v-stepper v-model="selectedStep">
            <v-stepper-header class="mb-3">
              <template v-for="(item,i) in stepList">
                <v-stepper-step
                  :key="`${i}-step`"
                  :complete="status >= i && published != 2"
                  :step="item.id"
                  :editable="status >= i && published != 2"
                  edit-icon="mdi-check"
                  error-icon="mdi-close"
                  complete-icon="mdi-check"
                >{{ item.name }}</v-stepper-step>

                <v-divider v-if="i !== stepList.length -1" v-bind:key="`${i}-steps`"></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content :step="1" class="pa-0">
                <v-skeleton-loader v-if="loading" type="table-heading, table-tbody, table-tfoot"></v-skeleton-loader>
                <v-card class="mb-12" flat v-if="!loading">
                  <v-form v-model="valid" ref="formData">
                    <v-card class="pa-0" color="#f1f7fb" flat>
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <v-card color="primary" dark tile class="pa-0">
                            <v-card-title>{{$t('payroll_process')}}</v-card-title>
                            <v-card-subtitle>{{dataItem.periodName}}</v-card-subtitle>
                          </v-card>
                          <v-card tile flat color="transparent">
                            <v-card-text>
                              <v-row align="center">
                                <v-col cols="12">
                                  <v-text-field
                                   :label="$t('period_type')"
                                    :value="translateType(dataItem.periodType)"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    :label="$t('start_date')"
                                    prepend-inner-icon="mdi-calendar"
                                    v-model="dataItem.startDate"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                   :label="$t('end_date')"
                                    prepend-inner-icon="mdi-calendar"
                                    v-model="dataItem.endDate"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                   :label="$t('attendance_start')"
                                    prepend-inner-icon="mdi-calendar"
                                    v-model="dataItem.startDateAtt"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                   :label="$t('attendance_end')"
                                    prepend-inner-icon="mdi-calendar"
                                    v-model="dataItem.endDateAtt"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                   :label="$t('pay_date')"
                                    prepend-inner-icon="mdi-calendar"
                                    v-model="dataItem.paymentDate"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <small>
                                    <label>{{$t('calculate_tax')}}</label>
                                  </small>
                                  <v-switch inset color="success" v-model="dataItem.calculateTax"></v-switch>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12" class="pa-0">
                          <v-card tile flat height="100%">
                            <v-card-title>
                              <v-row>
                                <v-col cols="4">{{$t('selected_employee')}}</v-col>
                                <v-col class="text-right">
                                  <!-- <v-btn outlined color="primary" @click="backPage" class="mr-2">{{$t('back')}}</v-btn> -->
                                  <v-btn color="primary" @click="showAddEmployee">{{$t('manage_employee')}}</v-btn>
                                  <!-- <v-btn
                                    :loading="loading"
                                    color="primary"
                                    :disabled="!valid"
                                    class="ml-2"
                                    @click="proccessDialogMet({usersId:selectedUser, periodId: dataItem.id, includeTax: dataItem.calculateTax})"
                                  >{{$t('process')}}</v-btn> -->
                                </v-col>
                              </v-row>
                            </v-card-title>
                            <v-card-text class="pb-0 pt-0">
                              <v-data-table
                                :loading="loading"
                                :headers="detailHeaders"
                                :items="dataItem.users"
                                item-key
                                :page="page"
                                @update:page="setPage($event)"
                                :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
                                disable-sort
                                hide-default-footer
                                :no-data-text="$t('no_data')"
                                height="500px"
                              >
                               <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
                                <template v-slot:item.no="{ index }">
                                  <span v-if="page==1">{{(index+1)}}</span>
                                  <span v-else>{{(index+1) + ((page-1)*10)}}</span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <v-btn
                                    outlined
                                    small
                                    depressed
                                    color="primary"
                                    @click="showSalaryDialog(item)"
                                  >{{$t('see_details')}}</v-btn>
                                </template>
                                <template v-slot:top="{ pagination, options, updateOptions }">
                                  <v-data-footer 
                                    :pagination="pagination" 
                                    :options="options"
                                    @update:options="updateOptions"
                                    items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                                    :items-per-page-options="[10,50,100]"
                                    />
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-col style="background: white;" class="text-right">
                          <v-btn outlined color="primary" @click="backPage" class="mr-2">{{$t('back')}}</v-btn>
                          <v-btn
                            :loading="loading"
                            color="primary"
                            :disabled="!valid"
                            class="ml-2"
                            @click="proccessDialogMet({usersId:selectedUser, periodId: dataItem.id, includeTax: dataItem.calculateTax})"
                          >{{$t('process')}}</v-btn>
                          </v-col>
                    </v-card>
                  </v-form>
                  <!-- <v-card-actions class="mx-6 pb-6 mt-4">
                    <v-row>
                      <v-col cols="12" class="d-flex justify-space-between">
                        <v-btn outlined color="primary" @click="backPage">Back</v-btn>
                        <v-btn
                          :loading="loading"
                          color="primary"
                          :disabled="!valid"
                          @click="proccessDialogMet({usersId:selectedUser, periodId: dataItem.id, includeTax: dataItem.calculateTax})"
                        >Process</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions> -->
                </v-card>
              </v-stepper-content>

              <v-stepper-content :step="2">
                <v-card flat>
                  <v-skeleton-loader v-if="loading" type="table-heading, table-tbody, table-tfoot"></v-skeleton-loader>
                  <v-card-text class="pa-0" v-if="!loading && selectedStep == 2">
                    <vue-excel-editor
                      ref="grid"
                      v-model="excelData.data"
                      @update="onUpdate"
                      :costumReadonly="true"
                      :costumReadonlyParam="{text:'_ID', value: 0}"
                      :readonlyStyle="{'primary':1}"
                      height="500px"
                      :noHeaderEdit="true"
                    >
                      <vue-excel-column
                        v-for="(item,i) in excelData.headers"
                        v-bind:key="i"
                        :field="item.id"
                        :label="item.label"
                        :width="item.width"
                        :readonly="item.readonly"
                        :className="item.className"
                        :type="item.type"
                        :sticky="item.id == 'empcode' || item.id == 'name' ? true : false"
                      />
                    </vue-excel-editor>
                    <p class="warning--text text-center">
                     {{$t('warning_salary')}}
                    </p>
                  </v-card-text>
                  <v-card-actions class="mt-4">
                    <v-row>
                      <v-col cols="12" class="d-flex justify-space-between">
                        <v-btn color="primary" outlined @click="backStep">{{$t('back')}}</v-btn>
                        <v-btn color="primary" @click="generateSummary(periodId)">{{$t('generate')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>

              <v-stepper-content :step="3">
                <v-row class="pa-0">
                  <v-col cols="6">
                    <v-card color="#f1f7fb">
                      <v-card-text>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              readonly
                             :label="$t('start_process')"
                              :value="formatDateToDate(detailSummary.startProcess)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              readonly
                             :label="$t('end_process')"
                              :value="formatDateToDate(detailSummary.endProcess)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              readonly
                              :label="$t('total_process')"
                              :value="detailSummary.totalProcess"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              readonly
                              :label="$t('total_success')"
                              :value="detailSummary.totalSuccess"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="6">
                    <v-row align="center" justify="center" class="mt-1">
                      <v-col cols="6">
                        <h3>{{$t('payroll_report')}}:</h3>
                      </v-col>
                      <v-col cols="6">
                        <v-btn :href="linkDownload" color="primary">{{$t('download')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="text-right">
                    <v-btn @click="publish" :disabled="published >= 1" :loading="loadingPublish" color="success" class="ma-2">
                      {{getStatus}}
                    </v-btn>
                    <v-btn @click="checkPublishPorggress" v-if="published == 1" icon color="primary">
                      <v-icon>mdi-sync</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </v-card>
    </v-container>

    <v-dialog v-model="salaryDialog" max-width="1000px">
      <v-card class="mh-65 pa-0 ma-0" tile flat>
        <v-card-text>
          <salaries
            v-if="salaryDialog"
            v-bind:userId="selectedUserId"
            v-bind:loadData="true"
            v-bind:disableAdd="true"
            v-bind:showCloseButton="true"
            @close="salaryDialog = false"
          ></salaries>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addEmployeeDialog" max-width="550px">
      <v-card class="mx-auto">
        <v-card-title class="white--text primary">
          {{$t('manage_employee')}}
          <v-spacer></v-spacer>
          <v-checkbox dark @change="selectAll"
          :label="$t('select_all')"
          ></v-checkbox>
        </v-card-title>
        <v-divider></v-divider>
        <div class="container">
          <v-layout row>
            <v-flex md11 class="pl-3" shrink>
              <v-text-field :rules="[validator.alfaNumberNotRequired]" placeholder="Search" v-model="searchEmployee" @keyup="changeSearch"></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <v-list two-line v-if="!loadingVlist">
          <div class="container" v-if="showNoData" style="height:300px">
            <v-card class="text-center">
              <v-card-text>{{$t('no_data')}}</v-card-text>
            </v-card>
          </div>
          <v-virtual-scroll :items="userList" :item-height="64" height="300" v-if="!showNoData">
            <template v-slot:default="{ item }">
              <v-list-item-group multiple v-model="selectedUser">
                <v-list-item :key="item.title" :value="item.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="1">
                          <v-btn icon v-if="!active">
                            <v-icon>mdi-checkbox-blank-outline</v-icon>
                          </v-btn>
                          <v-btn icon v-if="active" color="primary">
                            <v-icon>mdi-checkbox-marked</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col>
                          <v-list-item-title v-text="item.fullName" class="text--primary"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </template>
          </v-virtual-scroll>
        </v-list>
        <v-skeleton-loader v-if="loadingVlist" type="table-tbody" style="height:300"></v-skeleton-loader>
        <v-card-actions class="mx-6 pb-6">
          <v-row>
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn color="primary" text @click="addEmployeeDialog = false">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="saveSelectUser"
                :disabled="!valid"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog overlay-opacity="0.7" v-model="proccessDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('process')}}?</v-card-title>
        <v-card-text>{{$t('sure_process')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="proccessDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="primary" :loading="loading" @click="processSummary(bodyProccess)">{{$t('process')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" style="z-index:10!important;">
      <v-progress-circular
        class="white radius-50"
        :rotate="360"
        :size="100"
        :width="15"
        :value="loadingValue"
        color="primary"
      >
        <AnimateNumber :number="loadingValue" />
      </v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
// import axios from 'axios'
import Salaries from './Salaries.vue'
import moment from 'moment'
import AnimateNumber from './../../../Summary/components/AnimateNumber.vue'
export default {
  components: {
    Salaries,
    AnimateNumber
  },
  name: "PayrollSummary",
  data() {
    return {
      overlay:false,
      loadingValue: 0,
      bodyProccess: {},
      showNoData: false,
      searchEmployee: '',
      loading: false,
      excelData: {},
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      periodId: this.$store.getters.pGetData('periodId'),

      selectedStep: 1,
      steps: 3,
      stepList: [
        { id: 1, name: this.$i18n.t('process') },
        { id: 2, name: this.$i18n.t('review')},
        { id: 3, name: this.$i18n.t('report') },
      ],
      status: this.$store.getters.pGetData('status'),
      companyId: this.$store.state.company,
      detailHeaders: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('name'), value: "fullName" },
        { text: this.$i18n.t('position'), value: "position" },
        { text: this.$i18n.t('action'), value: "action" },
      ],

      page: 1,
      valid: true,
      dataItem: {},
      selectedUser: [],
      userList: [],
      tempUserList: [],
      addEmployeeDialog: false,
      salaryDialog: false,
      detailSummary: {},
      linkDownload: '',
      loadingPublish: false,
      published: 0,
      loadingVlist: false,
      proccessDialog: false,
    };
  },
  computed: {
    getStatus() {
      switch(this.detailSummary.isPublished) {
        case 0: return this.$i18n.t('publish')
        case 1: return this.$i18n.t('publishing')
        case 2: return this.$i18n.t('published')
        default: return ''
      }
    }
  },
  methods: {
    getOverlayLoading() {
      return new Promise(async (resolve) => {
        this.overlay = true
        const result = await this.$store.dispatch('getPayrollProccessProgress', { periodId: this.periodId })
        if (result.percentage == 100) {
          this.loadingValue = result.percentage
          setTimeout(async () => {
            this.loading = false
            this.overlay = false
            this.showMessage('success', this.$i18n.t('alert_save'))
            this.dataItem = await this.getDetail(this.periodId)
            if (this.dataItem.status == 1) {
              this.selectedStep = 2
            } else {
              this.selectedStep = 1
            }
            resolve(true)
          }, 500);
        } else {
          this.loadingValue = result.percentage
          setTimeout(() => {
            this.getOverlayLoading()
          }, 1000);
          resolve(true)
        }
      }) 
    },
    proccessDialogMet(body) {
      this.bodyProccess = body
      this.proccessDialog = true
    },
    selectAll(event) {
      this.loadingVlist = true
      if (event) {
        this.searchEmployee = ''
        this.userList = this.tempUserList
        this.selectedUser = []
        this.userList.map(item => {
          this.selectedUser.push(item.id)
        })
      } else {
        this.selectedUser = []
        this.searchEmployee = ''
        this.userList = this.tempUserList
      }
      setTimeout(() => {
        this.loadingVlist = false
      }, 300);
    },
    changeSearch(event) {
      const value = event.target.value
      this.loadingVlist = true
      if (value.length > 0) {
        this.userList = this.tempUserList.filter(e => {
           if (e.fullName.includes(value) || e.email.includes(value)) {
             return e
           }
        })
        if (this.userList.length <= 0) {
          this.showNoData = true
        } else {
          this.showNoData = false
        }
      } else {
        this.userList = this.tempUserList
      }
      setTimeout(() => {
        this.loadingVlist = false
      }, 300);
    },
    async checkPublishPorggress() {
       this.loadingPublish = true
      const result = await this.$store.dispatch('forcePublishPayroll', {userId: this.$store.getters.user.id, periodId: this.periodId})
      this.loadingPublish = false
      if (result) {
        this.detailSummary = await this.getSummaryDetail(this.periodId)
      }
    },
    async publish() {
      this.loadingPublish = true
      const result = await this.$store.dispatch('generateAllPayslip', {companyId: this.companyId, periodId: this.periodId})
      this.loadingPublish = false
      if (result) {
        this.detailSummary = await this.getSummaryDetail(this.periodId)
      }
      
    },
    setPage(page) {
      this.page = page
    },
    showSalaryDialog(item) {
      this.selectedUserId = item.userId
      this.salaryDialog = true
      return true
    },
    translateType(type) {
      switch (type) {
        case 1: return 'Payroll'
        case 2: return 'Bonus'
        case 3: return 'THR'
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    exportExcel() {
      const format = 'xlsx'
      const exportSelectedOnly = false
      const filename = 'Namanya'
      this.$refs.grid.exportTable(format, exportSelectedOnly, filename)
    },
    async onUpdate(records) {
      const data = records[0]
      let body
      if (data) {
        body = {
          id: data.rowData[`${data.name}_ID`],
          userId: data.rowData.userId,
          periodId: data.rowData.periodId,
          amount: data.newVal,
        }
        const result = await this.$store.dispatch('editPayrollSummary', body)
        if (result == true) {
          this.showMessage('success', this.$i18n.t('alert_save'))
        }
      }
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    async getSummaryPayroll(periodId) {
      this.loading = true
      const result = await this.$store.dispatch("getPayrollSummary", { periodId });
      this.loading = false
      return result
    },
    async getDetail(periodId) {
      const result = await this.$store.dispatch('getPayrollPeriodDetail', { periodId })
      this.$store.dispatch('setStatusId', result.status)
      this.status = this.$store.getters.pGetData('status')
      return result
    },
    async getUsers(periodId) {
      const userId = this.$store.getters.user.id
      const result = await this.$store.dispatch('getUserByCompanyId', { userId, periodId })
      return result
    },
    // async editedItem() {
    //   const data = await this.getDetail(item.periodId)
    //   this.isEdit = true
    //   this.dataItem = Object.assign({}, data);
    //   this.dataItem.periodType = this.getPeriodType(this.dataItem.periodType)
    //   this.reselectEmployee()
    //   this.dialog = true
    // },
    chooseStep(status) {
      switch (status) {
        case 0:
          this.selectedStep = 1
          break
        case 1:
          this.selectedStep = 2
          break
        case 2:
          this.selectedStep = 3
          break
      }
    },
    showAddEmployee() {
      this.reselectEmployee()
      this.addEmployeeDialog = true
      this.userList = this.tempUserList
      this.searchEmployee = ''
    },
    reselectEmployee() {
      this.selectedUser = []
      if (this.dataItem.users) this.dataItem.users.map(item => {
        this.selectedUser.push(item.userId)
      })
    },
    checkUsersSelected() {
      return this.selectedUser.length > 0 ? false : true
    },
    async processSummary(body) {
      if (this.checkUsersSelected()) {
        this.showMessage('warning', 'Selected Employee Must be 1 or more')
        return null
      }
      this.loading = true
      setTimeout(() => {
        this.proccessDialog = false
        this.getOverlayLoading()
      }, 1000);
      this.$store.dispatch('savePayrollProcess', body)

      // const result = await this.$store.dispatch('savePayrollProcess', body)
      // this.loading = false
      // if (result) {
      //   this.showMessage('success', this.$i18n.t('alert_save'))
      //   this.dataItem = await this.getDetail(this.periodId)
      //   if (this.dataItem.status == 1) {
      //     this.selectedStep = 2
      //   }
      //   // this.dialog = false
      // }
    },
    async saveSelectUser() {
      this.loading = true
      const result = await this.$store.dispatch('savePayrollUsers', { periodId: this.dataItem.id, users: this.selectedUser })
      this.loading = false
      if (result == true) {
        this.showMessage('success', 'Saved Success')
        this.addEmployeeDialog = false
        this.refreshData()
      }
    },
    backPage() {
      this.$router.push({ name: "payroll-process" });
    },
    backStep() {
      this.selectedStep--
    },
    formatDateToDate(date) {
      return moment(date).format("Do MMMM YYYY, HH:mm:ss")
    },
    async generateSummary(periodId) {
      const result = await this.$store.dispatch('saveSummaryPayroll', { periodId })
      if (result == true) {
        this.refreshData()
        this.selectedStep++
        this.showMessage('success', this.$i18n.t('alert_generated'))
      }
    },
    async getSummaryDetail(periodId) {
      return await this.$store.dispatch('getSummaryPayroll', { periodId })
    },
    async getSummaryDetailDownload(periodId) {
      return await this.$store.dispatch('getSummaryPayrollDownload', { periodId })
    },
    async refreshData() {
      this.dataItem = await this.getDetail(this.periodId)
      this.reselectEmployee()
    }
  },
  async created() {
    if (this.periodId != null) {
      this.loading = true
      this.userList = await this.getUsers(this.periodId)
      this.tempUserList = this.userList
      this.dataItem = await this.getDetail(this.periodId)
      this.reselectEmployee()
      if (this.dataItem.statusProcess) {
        this.getOverlayLoading()
      } else {
        this.chooseStep(this.dataItem.status)
      }
      this.loading = false
    } else {
      this.$router.push({ name: "payroll-process" });
    }
  },
  watch: {
    detailSummary(item = {}) {
      this.published = item.isPublished
    },
    async selectedStep(e) {
      switch (e) {
        case 1:
          this.dataItem = await this.getDetail(this.periodId)
          this.reselectEmployee()
          break
        case 2:
          this.excelData = {}
          setTimeout(async () => {
            this.excelData = await this.getSummaryPayroll(this.periodId)
          }, 300);
          break
        case 3:
          this.detailSummary = await this.getSummaryDetail(this.periodId)
          this.linkDownload = await this.getSummaryDetailDownload(this.periodId)
          break
      }
    },
  }
};
</script>
<style>
/* This Style is used inside vue-excel-editor */
/* .readonly {
  background-color: rgba(255, 138, 138, 0.129);
} */
.sae-blue {
  background-color: #dfefff !important;
  border-color: #dfefff !important;
}
.sae-red {
  background-color: #fae0e0 !important;
  border-color: #fae0e0 !important;
}
.sae-green {
  background-color: #d4efc6 !important;
  border-color: #d4efc6 !important;
}
.radius-50 {
  border-radius: 50%;
}
</style>